export interface FilterPdfProps {
  year: string | null;
  month: string | null;
  flareName: string | null;
}

export const MenuExportPdf = ["/vocs-inventory/flare/report-government"];
